/* TrueSanity lux home page. Small and dependency-free; loaded with defer from sections/ts-home-feature (hero).
   1 films load late (after the page has loaded, or near the screen) and pause off screen
   2 stone dots swap the card photo
   3 Trending tabs + arrows
   4 returning visitors: "Continue where you left off" (last piece viewed + bag) and Recently viewed
   5 enticer tracking: impressions and clicks per piece, per spot, per position */
(function () {
  'use strict';
  var d = document, w = window;
  var mobile = w.matchMedia('(max-width: 749px)');
  var calm = w.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    (navigator.connection && navigator.connection.saveData);
  var idle = w.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };

  /* 1. films */
  function startFilm(v) {
    if (v.dataset.on) return;
    v.dataset.on = '1';
    v.src = mobile.matches ? (v.dataset.m || v.dataset.d) : v.dataset.d;
    v.addEventListener('playing', function () { v.style.opacity = '1'; }, { once: true });
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function films() {
    var vids = d.querySelectorAll('.tsh-film');
    if (!vids.length || calm) {
      vids.forEach(function (v) { ['.tsh-play', '.tsh-sound'].forEach(function (q) { var b = v.parentNode.querySelector(q); if (b) b.hidden = true; }); });
      return;
    }
    var seen = 'IntersectionObserver' in w ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.dataset.hero || v.dataset.ready) startFilm(v);
          if (v.dataset.on && !v.dataset.user) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (v.dataset.on) { v.pause(); }
      });
    }, { rootMargin: '300px 0px' }) : null;
    vids.forEach(function (v) {
      if (v.dataset.hero) {
        var go = function () { idle(function () { v.dataset.ready = '1'; startFilm(v); }); };
        if (d.readyState === 'complete') go(); else w.addEventListener('load', go, { once: true });
      }
      if (seen) seen.observe(v); else startFilm(v);
      var b = v.parentNode.querySelector('.tsh-play');
      if (b) b.addEventListener('click', function () {
        var paused = b.getAttribute('aria-pressed') === 'true';
        if (paused) { v.dataset.user = ''; startFilm(v); v.play(); } else { v.dataset.user = '1'; v.pause(); }
        b.setAttribute('aria-pressed', paused ? 'false' : 'true');
        b.setAttribute('aria-label', paused ? 'Pause film' : 'Play film');
      });
      // sound: one film at a time; turning one on mutes the others and starts it if it was paused
      var sb = v.parentNode.querySelector('.tsh-sound');
      if (sb) sb.addEventListener('click', function () {
        var on = sb.getAttribute('aria-pressed') !== 'true';
        vids.forEach(function (o) {
          var ob = o.parentNode.querySelector('.tsh-sound');
          var me = o === v && on;
          o.muted = !me;
          if (ob) { ob.setAttribute('aria-pressed', me ? 'true' : 'false'); ob.setAttribute('aria-label', me ? 'Turn sound off' : 'Turn sound on'); }
        });
        if (on) {
          v.volume = 1;
          startFilm(v);
          v.dataset.user = '';
          if (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Pause film'); }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }
      });
    });
  }

  /* 2. stone dots: hover shows that stone (only with a real mouse; on phones a tap just opens that stone's piece,
     because a phone "tap = hover" swapped the photo, never swapped it back, and on iPhone could eat the first tap) */
  var hover = w.matchMedia('(hover: hover) and (pointer: fine)');
  function back(img) {
    if (!img.dataset.o) return;
    if (img.getAttribute('src') !== img.dataset.o) img.src = img.dataset.o;
    if (img.dataset.os && img.getAttribute('srcset') !== img.dataset.os) img.setAttribute('srcset', img.dataset.os);
  }
  function dots(root) {
    root.querySelectorAll('.tsh-card').forEach(function (c) {
      var img = c.querySelector('.tsh-card__img img');
      if (!img || c.dataset.dots) return;
      c.dataset.dots = '1';
      img.dataset.o = img.getAttribute('src') || '';
      img.dataset.os = img.getAttribute('srcset') || '';
      var show = function (a) { if (!hover.matches) return; img.removeAttribute('srcset'); img.src = a.dataset.img; };
      c.querySelectorAll('.tsh-dot[data-img]').forEach(function (a) {
        a.addEventListener('mouseenter', function () { show(a); });
        a.addEventListener('focus', function () { if (a.matches(':focus-visible')) show(a); });
        a.addEventListener('blur', function () { back(img); });
      });
      var g = c.querySelector('.tsh-dots');
      if (g) g.addEventListener('mouseleave', function () { back(img); });
      // tap / click a stone: the card becomes that stone (photo, name, stone line, price, links); no page load
      c.querySelectorAll('.tsh-dot[data-pid]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // new tab still opens the piece
          e.preventDefault();
          if (a.classList.contains('is-on')) return;
          img.dataset.o = a.dataset.img; img.dataset.os = a.dataset.srcset || '';
          if (a.dataset.srcset) img.setAttribute('srcset', a.dataset.srcset); else img.removeAttribute('srcset');
          img.src = a.dataset.img;
          var set = function (sel, v) { var el = c.querySelector(sel); if (el && v != null) { el.textContent = v; el.hidden = !v; } };
          set('.tsh-card__name', a.dataset.name); set('.tsh-card__sub', a.dataset.sub); set('.tsh-card__price', a.dataset.price); set('.tsh-card__rating', a.dataset.rating || '');
          c.querySelectorAll('.tsh-card__img, .tsh-card__body').forEach(function (l) { l.href = a.getAttribute('href'); });
          c.querySelectorAll('.tsh-dot[data-pid]').forEach(function (o) { var on = o === a; o.classList.toggle('is-on', on); if (on) o.setAttribute('aria-current', 'true'); else o.removeAttribute('aria-current'); });
          c.dataset.tsPid = a.dataset.pid;
        });
      });
    });
  }

  /* 2b. back button. Phones keep a frozen copy of the page and show it again on "back" without running this
     file again, so: every card gets its own photo back, photos that never loaded (often the pieces further
     along a sideways row) load as they come near the screen, films on screen play again, and the
     "Continue where you left off" and Recently viewed rows pick up the piece just viewed. */
  function wake() {
    d.querySelectorAll('.tsh-card__img img').forEach(back);
    var late = 'IntersectionObserver' in w ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = e.target; late.unobserve(i);
        if (i.complete && i.naturalWidth) return;
        i.loading = 'eager';
        setTimeout(function () {
          if (i.complete && i.naturalWidth) return;
          var s = i.getAttribute('srcset'), u = i.getAttribute('src');
          if (s) { i.removeAttribute('srcset'); i.setAttribute('srcset', s); }
          if (u) i.src = u;
        }, 400);
      });
    }, { rootMargin: '400px 400px' }) : null;
    d.querySelectorAll('.tsh img').forEach(function (i) {
      if (i.complete && i.naturalWidth) return;
      if (late) late.observe(i); else i.loading = 'eager';
    });
    d.querySelectorAll('.tsh-film').forEach(function (v) {
      if (!v.dataset.on || v.dataset.user) return;
      var r = v.getBoundingClientRect();
      if (r.bottom > 0 && r.top < w.innerHeight) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
    cont(); rv();
  }
  w.addEventListener('pageshow', function (e) { if (e.persisted) wake(); });

  /* 3. trending tabs + arrows */
  function rails() {
    d.querySelectorAll('[data-tsh-tabs]').forEach(function (box) {
      var tabs = box.querySelectorAll('[role=tab]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var on = o === t;
            o.setAttribute('aria-selected', on ? 'true' : 'false');
            o.tabIndex = on ? 0 : -1;
            var p = d.getElementById(o.getAttribute('aria-controls')); if (p) p.hidden = !on;
          });
          track(box.querySelector('.tsh-panel:not([hidden])'));
        });
      });
    });
    d.querySelectorAll('.tsh-rail').forEach(function (r) {
      var t = r.querySelector('.tsh-rail__track'), pv = r.querySelector('.tsh-arrow--p'), nx = r.querySelector('.tsh-arrow--n');
      if (!t || !pv || !nx) return;
      var upd = function () { pv.disabled = t.scrollLeft < 4; nx.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4; };
      pv.addEventListener('click', function () { t.scrollBy({ left: -t.clientWidth, behavior: 'smooth' }); });
      nx.addEventListener('click', function () { t.scrollBy({ left: t.clientWidth, behavior: 'smooth' }); });
      t.addEventListener('scroll', function () { w.requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }

  /* 4. returning visitors */
  function recent() {
    var list = [];
    try { list = JSON.parse(localStorage.getItem('recently_viewed') || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];
    return list.filter(function (i) { return i && i.productUrl && i.productTitle; });
  }
  function big(src) { return String(src || '').replace(/_(medium|small|compact|large)\./, '_500x.'); }
  // a saved piece with no photo, or a photo that no longer loads (older visits saved before the photos were
  // added, or old file names): ask Shopify for the piece's current photo, show it and fix the saved copy
  function heal(img, item) {
    var done = false;
    function fix() {
      if (done) return; done = true;
      var u = String(item.productUrl || '').split('?')[0];
      if (!u) return;
      fetch(u + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        var src = p && (p.featured_image || (p.images && p.images[0]));
        if (!src) return;
        src = String(src); var sized = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=500';
        img.src = sized;
        try {
          var l = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
          l.forEach(function (x) { if (x && x.productUrl === item.productUrl) x.productImg = sized; });
          localStorage.setItem('recently_viewed', JSON.stringify(l));
        } catch (e) {}
      }).catch(function () {});
    }
    if (!item.productImg || /no-image/.test(item.productImg)) { fix(); return; }
    img.addEventListener('error', fix, { once: true });
    if (img.complete && !img.naturalWidth && img.getAttribute('src')) fix();
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function short(t) { var p = String(t).split(' - '); return p.length > 1 ? p[p.length - 1] + ' · ' + p.slice(0, -1).join(' - ') : t; }

  function rv() {
    var box = d.querySelector('[data-tsh-recent]');
    if (!box) return;
    var items = recent().slice(0, 8);
    if (items.length < 2) return;
    var ul = box.querySelector('.tsh-rv__list');
    ul.innerHTML = items.map(function (i) {
      var gems = Array.isArray(i.otherGemstones) && i.otherGemstones.length > 1 ? i.otherGemstones.slice(0, 4) : [];
      var dotsHtml = gems.map(function (g, n) {
        return '<span class="tsh-dot' + (n === 0 ? ' is-on' : '') + '" data-u="' + esc(g.url) + '" title="' + esc(g.title) + '"><img src="' + esc(g.image) + '" alt="" width="16" height="16" loading="lazy"></span>';
      }).join('');
      return '<a href="' + esc(i.productUrl) + '" data-ts-spot="recent" data-ts-pid="' + esc(i.pdpId) + '">' +
        '<img src="' + esc(big(i.productImg)) + '" alt="" loading="lazy" width="250" height="250">' +
        '<span class="tsh-rv__t">' + esc(i.productTitle) + '</span>' +
        '<span class="tsh-rv__p">' + esc(i.productPrice) + '</span>' +
        (dotsHtml ? '<span class="tsh-dots">' + dotsHtml + '</span>' : '') + '</a>';
    }).join('');
    ul.querySelectorAll(':scope > a > img').forEach(function (im, n) { heal(im, items[n]); });
    ul.querySelectorAll(':scope > a').forEach(rvDots);
    box.hidden = false;
  }

  /* 4b. Recently viewed stone dots: hovering a stone (real mouse only) shows that stone's piece: photo, name
     and price, fetched once from Shopify and kept; leaving the dots puts the viewed piece back. Clicking or
     tapping a stone opens that stone's piece (new-tab clicks too). */
  var rvCache = {};
  function rvPiece(u) {
    if (!rvCache[u]) {
      rvCache[u] = fetch(u.split('?')[0] + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return rvCache[u];
  }
  function rvDots(a) {
    var dots = a.querySelectorAll('.tsh-dot[data-u]');
    if (dots.length < 2) return;
    var img = a.querySelector(':scope > img'), t = a.querySelector('.tsh-rv__t'), pr = a.querySelector('.tsh-rv__p');
    var cur = (w.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var home = null, want = null;
    function save() { if (!home) home = { src: img.getAttribute('src'), t: t.textContent, p: pr.textContent, href: a.getAttribute('href') }; }
    function mark(on) { dots.forEach(function (o) { o.classList.toggle('is-on', o === on); }); }
    function restore() {
      want = null;
      if (!home) return;
      img.src = home.src; t.textContent = home.t; pr.textContent = home.p;
      mark(dots[0]);
    }
    dots.forEach(function (dot, n) {
      var u = dot.dataset.u;
      dot.addEventListener('mouseenter', function () {
        if (!hover.matches) return;
        if (n === 0) { restore(); return; }
        save(); want = u; mark(dot);
        rvPiece(u).then(function (p) {
          if (!p || want !== u) return;
          var src = p.featured_image || (p.images && p.images[0]);
          if (src) { src = String(src); img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=500'; }
          if (p.title) t.textContent = p.title;
          if (typeof p.price === 'number') pr.textContent = money(p.price, cur);
        });
      });
      dot.addEventListener('click', function (e) {
        if (!u || n === 0) return;
        e.preventDefault(); e.stopPropagation();
        if (e.metaKey || e.ctrlKey || e.shiftKey) w.open(u, '_blank'); else w.location.href = u;
      });
    });
    var g = a.querySelector('.tsh-dots');
    if (g) g.addEventListener('mouseleave', restore);
    a.addEventListener('mouseleave', restore);
  }

  function money(cents, cur) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch (e) { return '$' + Math.round(cents / 100).toLocaleString(); }
  }
  function cont() {
    var box = d.querySelector('[data-tsh-continue]');
    if (!box) return;
    var items = recent();
    if (!items.length) return;
    var i = items[0];
    var a = box.querySelector('.tsh-cont__item');
    a.href = i.productUrl;
    var ci = a.querySelector('img');
    if (i.productImg) ci.src = big(i.productImg);
    heal(ci, i);
    a.querySelector('.tsh-cont__name').textContent = short(i.productTitle);
    a.querySelector('.tsh-cont__price').textContent = i.productPrice || '';
    box.hidden = false;
    var intl = box.dataset.intl === '1';
    fetch((w.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || !c.item_count) return;
        var bag = box.querySelector('.tsh-cont__bag'), ask = box.querySelector('.tsh-cont__ask');
        var n = c.item_count, total = c.total_price, cur = c.currency, dollars = total / 100;
        bag.querySelector('[data-n]').textContent = n + (n === 1 ? ' item' : ' items');
        bag.querySelector('[data-total]').textContent = money(total, cur);
        var tier = dollars > 2000 ? 'Free gift included, $2,001+ tier' : dollars > 500 ? 'Free gift included, $501 to $2,000 tier' : 'Free gift included';
        var ship = intl ? (dollars >= 2000 ? 'free shipping' : 'free shipping over $2,000') : 'free US shipping';
        var giftOn = box.dataset.gift === '1';
        bag.querySelector('[data-note]').textContent = giftOn ? tier + ' · ' + ship : ship.charAt(0).toUpperCase() + ship.slice(1);
        var th = bag.querySelector('.tsh-cont__thumbs');
        if (n > 1) {
          th.innerHTML = c.items.slice(0, 4).map(function (it) {
            var src = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;
            return src ? '<img src="' + esc(src) + (String(src).indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="' + esc(it.product_title) + '" width="52" height="52" loading="lazy">' : '';
          }).join('');
          th.hidden = false;
        }
        bag.hidden = false; ask.hidden = true;
      }).catch(function () {});
  }

  /* 5. enticer tracking: one impression per piece per page view (half of it on screen), plus clicks.
     Sent to Shopify customer events (custom pixel) and to Google tags when present. */
  function send(name, data) {
    try { if (w.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { if (typeof w.gtag === 'function') w.gtag('event', name, data); else (w.dataLayer = w.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
  }
  function info(el) {
    var m = d.querySelector('[data-ts-month]');
    return { spot: el.dataset.tsSpot, position: el.dataset.tsPos || '', product_id: el.dataset.tsPid || '', month: m ? m.dataset.tsMonth : '' };
  }
  var io = 'IntersectionObserver' in w ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { io.unobserve(e.target); send('ts_enticer_impression', info(e.target)); }
    });
  }, { threshold: 0.5 }) : null;
  function track(root) {
    if (!root) return;
    root.querySelectorAll('.tsh-card[data-ts-spot]').forEach(function (c) {
      if (c.dataset.tracked) return;
      c.dataset.tracked = '1';
      if (io) io.observe(c);
    });
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    var el = a.closest('[data-ts-spot]');
    if (!el || !el.closest('.tsh')) return;
    var data = info(el);
    if (a.classList.contains('tsh-dot')) {
      data.via = 'stone';
      // a stone tap now swaps the card instead of opening the piece; counted on its own (new-tab clicks still open it)
      if (a.dataset.pid && !(e.metaKey || e.ctrlKey || e.shiftKey)) { data.stone_pid = a.dataset.pid; send('ts_enticer_stone', data); return; }
    }
    send('ts_enticer_click', data);
  });

  function init() {
    films();
    dots(d);
    rails();
    d.querySelectorAll('.tsh').forEach(function (s) { if (!s.closest('.tsh-panel[hidden]')) track(s); });
    idle(function () { cont(); rv(); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
